S.event =
    {
        elements: {
            $image: null,
        },


        init()
        {
            $(window).on('resize', () =>
            {
                this.elements.$image.find('img').height(this.elements.$image.find('img').width() / 2);
            }).resize();
        },
    };
